import { produce } from "immer";
import { SiteSettingsAction, GET_SITE_SETTINGS } from "./settings.actions";
import UmbracoSettingsRootState from "../models/settings-redux-state.interface";

const initialState: UmbracoSettingsRootState = {
    content: undefined
};

export default (settingsState = initialState, action: SiteSettingsAction): UmbracoSettingsRootState => produce(settingsState, draft => {
    switch (action.type) {
        case GET_SITE_SETTINGS: {
            draft.content = action.content;
            break;
        }
    }
});
